import BlockModel from '@wre/infinity-generators/SchemeOfLearning/Year3/Autumn/MultiplicationAndDivisionA/index';
import { newBlockContent } from '../../../Block';
import { newSmallStepContent } from '../../../SmallStep';

const Block = newBlockContent({
  block: 'MultiplicationAndDivisionA',
  field: 'Number',
  weeks: [9, 12],
  smallSteps: [
    // Step 1
    newSmallStepContent({
      ...BlockModel.smallSteps[0],
      module: () =>
        import(
          /* webpackChunkName: "Year3/Autumn/MultiplicationAndDivisionA/1MultiplicationEqualGroups" */ './1MultiplicationEqualGroups'
        )
    }),
    // Step 2
    newSmallStepContent({
      ...BlockModel.smallSteps[1],
      module: () =>
        import(
          /* webpackChunkName: "Year3/Autumn/MultiplicationAndDivisionA/2UseArrays" */ './2UseArrays'
        )
    }),
    // Step 3
    newSmallStepContent({
      ...BlockModel.smallSteps[2],
      module: () =>
        import(
          /* webpackChunkName: "Year3/Autumn/MultiplicationAndDivisionA/3MultiplesOf2" */ './3MultiplesOf2'
        )
    }),
    // Step 4
    newSmallStepContent({
      ...BlockModel.smallSteps[3],
      module: () =>
        import(
          /* webpackChunkName: "Year3/Autumn/MultiplicationAndDivisionA/4MultiplesOf5And10" */ './4MultiplesOf5And10'
        )
    }),
    // Step 5
    newSmallStepContent({
      ...BlockModel.smallSteps[4],
      module: () =>
        import(
          /* webpackChunkName: "Year3/Autumn/MultiplicationAndDivisionA/5SharingAndGrouping" */ './5SharingAndGrouping'
        )
    }),
    // Step 6
    newSmallStepContent({
      ...BlockModel.smallSteps[5],
      module: () =>
        import(
          /* webpackChunkName: "Year3/Autumn/MultiplicationAndDivisionA/6MultiplyBy3" */ './6MultiplyBy3'
        )
    }),
    // Step 7
    newSmallStepContent({
      ...BlockModel.smallSteps[6],
      module: () =>
        import(
          /* webpackChunkName: "Year3/Autumn/MultiplicationAndDivisionA/7DivideBy3" */ './7DivideBy3'
        )
    }),
    // Step 8
    newSmallStepContent({
      ...BlockModel.smallSteps[7],
      module: () =>
        import(
          /* webpackChunkName: "Year3/Autumn/MultiplicationAndDivisionA/8The3TimesTable" */ './8The3TimesTable'
        )
    }),
    // Step 9
    newSmallStepContent({
      ...BlockModel.smallSteps[8],
      module: () =>
        import(
          /* webpackChunkName: "Year3/Autumn/MultiplicationAndDivisionA/9MultiplyBy4" */ './9MultiplyBy4'
        )
    }),
    // Step 10
    newSmallStepContent({
      ...BlockModel.smallSteps[9],
      module: () =>
        import(
          /* webpackChunkName: "Year3/Autumn/MultiplicationAndDivisionA/10DivideBy4" */ './10DivideBy4'
        )
    }),
    // Step 11
    newSmallStepContent({
      ...BlockModel.smallSteps[10],
      module: () =>
        import(
          /* webpackChunkName: "Year3/Autumn/MultiplicationAndDivisionA/11The4TimesTable" */ './11The4TimesTable'
        )
    }),
    // Step 12
    newSmallStepContent({
      ...BlockModel.smallSteps[11],
      module: () =>
        import(
          /* webpackChunkName: "Year3/Autumn/MultiplicationAndDivisionA/12MultiplyBy8" */ './12MultiplyBy8'
        )
    }),
    // Step 13
    newSmallStepContent({
      ...BlockModel.smallSteps[12],
      module: () =>
        import(
          /* webpackChunkName: "Year3/Autumn/MultiplicationAndDivisionA/13DivideBy8" */ './13DivideBy8'
        )
    }),
    // Step 14
    newSmallStepContent({
      ...BlockModel.smallSteps[13],
      module: () =>
        import(
          /* webpackChunkName: "Year3/Autumn/MultiplicationAndDivisionA/14The8TimesTable" */ './14The8TimesTable'
        )
    }),
    // Step 15
    newSmallStepContent({
      ...BlockModel.smallSteps[14],
      module: () =>
        import(
          /* webpackChunkName: "Year3/Autumn/MultiplicationAndDivisionA/15The24And8TimesTables" */ './15The24And8TimesTables'
        )
    })
  ]
});
export default Block;
